import React from 'react';

type Props = {
  remainingSimulatedDays: number;
  totalSimulatedDays: number;
};

export const calculateSessionProgress = (
  totalSimulatedDays: number,
  remainingSimulatedDays: number,
) => {
  if (!Number.isFinite(totalSimulatedDays) || totalSimulatedDays <= 0) return 0;

  const rawProgress =
    ((totalSimulatedDays - remainingSimulatedDays) / totalSimulatedDays) * 100;

  return Math.min(100, Math.max(0, Math.floor(rawProgress)));
};

const SessionProgress: React.FC<Props> = ({
  remainingSimulatedDays,
  totalSimulatedDays,
}) => {
  const progress = calculateSessionProgress(
    totalSimulatedDays,
    remainingSimulatedDays,
  );

  return (
    <div className="markets-v5-session-progress">
      <div
        className="markets-v5-session-progress__track"
        role="progressbar"
        aria-label={`Session progress: ${progress}% complete`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <span style={{ width: `${progress}%` }} />
      </div>
      <span className="markets-v5-session-progress__value" aria-hidden="true">
        {progress}%
      </span>
    </div>
  );
};

export default SessionProgress;
